/* eslint-disable no-unused-vars */
import GLightbox from 'glightbox'
require('glightbox/dist/css/glightbox.css')

const createLightboxInstance = () => {
	const videoInstance = document.querySelector('[data-lightbox="video"]')
    if(videoInstance) {
        GLightbox({
			selector: '[data-lightbox="video"]',
			touchNavigation: true,
			loop: true,
			autoplayVideos: true,
			plyr: {
				css: 'https://cdn.plyr.io/3.5.6/plyr.css',
				js: 'https://cdn.plyr.io/3.5.6/plyr.js'
			}
		});
	}

	const imageInstance = document.querySelector('[data-lightbox="image"]')
    if(imageInstance) {
        GLightbox({
			selector: '[data-lightbox="image"]',
			touchNavigation: true
		});
    }
}

window.addEventListener('load', () => {
	createLightboxInstance()
});



// WEBPACK FOOTER //
// ./js/modules/lightbox.js